import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "player", "audio", "name", "meta",
                    "mobileRow", "mobileRowLabel", "sheet", "sheetItem", "sheetCheck"];
  static values = { tracks: Object };

  change() {
    const id = this.selectTarget.value;
    this.#syncMobileRow(id);
    if (!id) {
      this.#hide();
      return;
    }
    const track = this.tracksValue[id];
    if (!track || !track.url) {
      this.#hide();
      return;
    }

    this.audioTarget.pause();
    this.audioTarget.src = track.url;
    this.audioTarget.load();

    if (this.hasNameTarget) this.nameTarget.textContent = track.name || "";
    if (this.hasMetaTarget) {
      const mins = Math.floor((track.duration || 0) / 60);
      const secs = Math.round((track.duration || 0) % 60).toString().padStart(2, "0");
      const mood = track.mood ? `${track.mood} · ` : "";
      this.metaTarget.textContent = `${mood}${mins}:${secs}`;
    }
    this.playerTarget.hidden = false;

    document.dispatchEvent(new CustomEvent("audio-player:pause-all", {
      detail: { except: this.playerTarget },
    }));
  }

  openSheet() {
    if (!this.hasSheetTarget) return;
    this.#syncSheetChecks(this.selectTarget.value);
    this.sheetTarget.hidden = false;
    document.body.style.overflow = "hidden";
  }

  closeSheet() {
    if (!this.hasSheetTarget) return;
    this.sheetTarget.hidden = true;
    document.body.style.overflow = "";
  }

  selectTrack(event) {
    const id = event.currentTarget.dataset.trackId;
    this.selectTarget.value = id;
    this.selectTarget.dispatchEvent(new Event("change"));
    this.#syncSheetChecks(id);
    this.closeSheet();
  }

  #syncMobileRow(id) {
    if (!this.hasMobileRowLabelTarget) return;
    if (id && this.tracksValue[id]) {
      this.mobileRowLabelTarget.textContent = this.tracksValue[id].name;
    } else {
      this.mobileRowLabelTarget.dataset.empty = "";
      this.mobileRowLabelTarget.textContent = this.mobileRowLabelTarget.dataset.placeholder || "";
    }
  }

  #syncSheetChecks(selectedId) {
    this.sheetItemTargets.forEach(item => {
      const check = item.querySelector("[data-bgm-check]");
      if (check) check.hidden = item.dataset.trackId !== String(selectedId);
    });
  }

  #hide() {
    if (this.hasPlayerTarget) {
      this.audioTarget.pause();
      this.playerTarget.hidden = true;
    }
  }
}
